<template lang="pug">
  .page
    section.head
      .bg.h-100.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/about_us_banner.webp)'}")
    section
      b-container
        .row
          .col-md-4.col-1
          .col-10.col-md-8.text-right
            h2 At Wall, we're building a community around art that matters.
            p
              | We combine expert curation with purpose-built solutions, to remove the barriers between premium art and the
              | people who benefit from it. Whether that's a boutique hotel, a corporate headquarters, or your living room wall.
              | Great art should be accessible enough to inspire daily life.
    section#sectionExist.bg-tertiary.pb-0
        .container.mr-0
          .row
            .col-md-6.p-5
              .container
                h1 Why We Exist
                p Galleries cater to a select group of established collectors.
                  |  Online platforms lack curation. Designers struggle with unreliable procurement,
                  | and talented artists can't access the clients who value their work.
                  br
                  br
                  | We exist to create pathways that connect people with elevated local fine artwork.
                  | By combining serious curatorial expertise with intentional and innovative solutions,
                  | we're making it possible for more people to live and work surrounded by premium fine art.
                  br
                  br
                  | Because when art enters more homes and spaces, everyone benefits. Artists gain sustainable livelihoods.
                  | Collectors discover work that transforms environments.
                  | Communities develop stronger cultural identities.
            .col-md-6.text-right
              img(src="https://cdn.wallcollective.co/resources/images/about_mash_3.webp")
    section#sectionDifferent.section-light
      .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/different_banner.webp)'}")
      b-container.text-dark
        .overlay
        .row
          .col-md-6
          .col-md-6.p-5
            h1.pb-3 What Makes Us Different
            h2 Solutions that remove barriers
            p We built our platform to make art procurement transparent and intuitive.
            h2 Flexible access to quality
            p Not everyone needs to purchase. Try before you buy or rotate seasonally to keep things fresh.
            h2 Empowering artists
            p Low commission rates, professional partnerships, and access to clients who value their work. We're passionate about creating sustainable careers for the artists we represent.
            h2 Community not transactions
            p We're building relationships that extend beyond individual projects. Post-installation support. Collection advisory. Studio visits. We want to create a community of people who believe art enriches life, and support them at every stage of that journey.
    section
      b-container.text-center
        h1.my-5 Who We Serve
        .row.text-left
          .col-md-3
            .tile.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/serve_collectors.webp)'}")
            h5 Collectors
            p From first-time buyers to established collectors - anyone who wants expert guidance and access to artists they won't find elsewhere.
          .col-md-3
            .tile.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/serve_artists.webp)'}")
            h5 Artists
            p We represent emerging and established talent whose work deserves broader exposure. If you're an artist creating exceptional work and seeking professional representation, we'd love to hear from you.
          .col-md-3
            .tile.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/serve_design.webp)'}")
            h5 Design Professionals
            p Interior designers, decorators, and architects who need reliable partners for client projects. We understand your timelines and reputation requirements.
          .col-md-3
            .tile.w-100.tile.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/serve_hospitality.webp)'}")
            h5 Hospitality & Corporate
            p Finterior designers, decorators, and architects who need reliable partners for client projects. We understand your timelines and reputation requirements.
    section#sectionServices(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/about_services_banner.webp)'}")
        .overlay
        b-container.content
          .row
            .col-md-6
              h1 Our Services
              ul
                li
                  span.strong Digital Platform
                  p Tech that makes complex projects effortless
                li
                  span.strong Rental Programs
                  p Flexible access to high quality art for any timeline
                li
                  span.strong Gallery
                  p Seamless browsing experience from a curated selection of hand-selected artwork
                li
                  span.strong Procurement & Project Management
                  p Complete coordination from specification through installation
                li
                  span.strong Art Consulting & Curation
                  p Expert advisory guidance tailored to your vision, space, and budget
                li
                  span.strong Custom Commission
                  p Site-specific works that bring your vision to life
    section#sectionCommitment.section-dark
      b-container
        h1 Our Commitment
        br
        .row
          .col-md-8.commitment
            .row
              .col-6.col-md-4
                h3.mt-1 To Artists
              .col-1.line_col.d-none.d-md-block
              .col-6
                p.text-white Fair compensation, professional partnerships, and opportunities to create meaningful projects.
              .col-6.col-md-4
                h3.mt-1 To Clients
              .col-1.line_col.d-none.d-md-block
              .col-6
                p.text-white Smooth communication, predictable timelines, transparent pricing, and excellent service.
              .col-6.col-md-4
                h3.mt-1 To Accessibility
              .col-1.line_col.d-none.d-md-block
              .col-6
                p.text-white Making exceptional art available to more people in more ways.
              .col-6.col-md-4
                h3.mt-1 To Quality
              .col-1.line_col.d-none.d-md-block
              .col-6
                p.text-white We stand behind everything we procure. If we wouldn't be proud to see it installed, we don't offer it.
          .col-md-4
            img.w-100(src="https://cdn.wallcollective.co/resources/images/about_commitment_square.webp")
        hr.text-light.my-5
      b-container
        .row
          .col-md-6
            h3 Where We Work
            p Based in South Africa, serving clients nationally and internationally. We manage logistics, customs, and installation coordination wherever your project takes us.
          .col-md-6
            h3 Join Our Community
            p Whether you're beginning your first project, building a collection, or looking for a long-term art partner, we'd welcome the opportunity to work together.
          .col-12.text-center
            b-button.btn-glass-light.m-3(:to="{name: 'gallery'}") Browse Artworks
            b-button.btn-glass-light.m-3(:to="{name: 'contact'}") Schedule a Consultation
            b-button.btn-glass-light.m-3(:to="{name: 'rentals'}") Learn about Rentals
</template>

<script>
import standardMix from '@/mixins/standardMix';
// import { apiService } from '@/services';
// import Vue from 'vue';
// import router from '@/router';

export default {
  metaInfo() {
    return { title: 'Wall Collective corporate art rental' };
  },
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>

#sectionExist {
  img {
    max-width: 100%;
    max-height: 100%;
  }
}

#sectionCommitment {
 background-color: #031C1D !important;
 hr {
      background-color: white;
    }
.commitment {
  // border-right: 2px solid white;
}
}

#sectionServices {
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  z-index: 0;
  .content {
    z-index: 100;
  }
  .overlay {
    background-color: rgba(white, 0.8);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    @media(min-width: 768px){
      width: 50%;
    }
  }
}

.tile {
  aspect-ratio: 1 / 1;
  background-position: center;
  background-size: cover;
}

.line_col {
  border-left: 1px solid white;
}

#sectionDifferent {
  position: relative;
  .bg {
    transform: scaleX(-1);
    position: absolute;
    left: 0;
    top: 0;
    background-position: bottom;
    background-repeat: no-repeat;
    z-index: 0;
    opacity: 1;
  }
  position: relative;
 .overlay {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  background-color: rgba(white, 0.8);
  @media(max-width: 768px){
      left: 0%;
      width: 100%;
    }
  height: 100%;
  z-index: 0;
  }
}

.bg-tertiary {
  img {
    margin-top: 50px;
    max-height: 500px;
  }
}

  .picture {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
.story-line {
  border-left: 1px solid black;
}
.head {
  background-color: black;
  z-index: 0;
  position: relative;
  height: 80vh;
  overflow: hidden;
  .bg {
    // background-attachment: fixed;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
    background-size: cover;
    background-position: center;
    // @include desktop {
    // background-image: url("@/assets/images/backgrounds/art1.jpg");
    // }
  }
}
.bg {
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: .7;
      z-index: -1;
    }
#sectionTestimonial {
  background-color: black;
  z-index: 0;
  position: relative;
  background-attachment: fixed;
  background-size: cover;
  background-position: bottom;
}
  .inst-tile {
    height: 100px;
  }
  .piece {
      transition: all ease-in 0.5s;
      margin: 15px;
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/About.vue